export default {"src":"/_next/static/media/quote-mark.e0a5774b.svg","height":33,"width":37,"blurWidth":0,"blurHeight":0};